import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import DataTable_v2 from "../components/DataTable_v2";
import Swal from "sweetalert2";
import UserDataTable from "../components/UserDataTable";
import UserDataTablePage_v2 from "./UserDataTablePage_v2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import FontAwesome
import {faUsers,faUserShield} from "@fortawesome/free-solid-svg-icons"; // Import specific icons
import UserRoleDataTablePage_v2 from "./UserRoleDataTablePage_v2";

const UserRolesManagement = () => {

  return (
    <div className="p-3">
      {/* Header */}
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-white rounded-lg shadow-xs border border-gray-100">
          <FontAwesomeIcon
            icon={faUserShield}
            className="text-lg text-purple-600"
          />
        </div>
        <div>
          <h1 className="text-lg font-semibold text-gray-800">
          User Roles Management
          </h1>
          <p className="text-xs text-gray-500 mt-0.5">List of Roles</p>
        </div>
      </div>
      <UserRoleDataTablePage_v2 />
    </div>
  );
};

export default UserRolesManagement;